<template>
  <div class="fm-modal-overlay" @click.self="$emit('cancel')">
    <div class="fm-modal">
      <h3 class="fm-modal-title">Nueva carpeta</h3>
      <input
        ref="input"
        class="fm-modal-input"
        v-model="name"
        placeholder="Nombre de la carpeta"
        @keyup.enter="confirm"
        @keyup.esc="$emit('cancel')"
      />
      <div class="fm-modal-actions">
        <button class="fm-btn-cancel" @click="$emit('cancel')">Cancelar</button>
        <button class="fm-btn-confirm" :disabled="!name.trim()" @click="confirm">Crear</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FMCreateFolder',
  data() { return { name: 'Nueva carpeta' } },
  mounted() { this.$nextTick(() => { this.$refs.input.select() }) },
  methods: {
    confirm() { if (this.name.trim()) this.$emit('confirm', this.name.trim()) }
  }
}
</script>
<style scoped>
.fm-modal-overlay {
  position: fixed; inset: 0;
  background: rgba(20,35,70,0.30); backdrop-filter: blur(4px);
  display: flex; align-items: center; justify-content: center; z-index: 500;
}
.fm-modal {
  background: var(--fm-surface); border: 1px solid var(--fm-border2);
  border-radius: 14px; padding: 24px; min-width: 320px;
  box-shadow: var(--fm-shadow);
  animation: fm-pop 0.18s ease;
}
@keyframes fm-pop {
  from { transform: scale(0.92); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}
.fm-modal-title { font-size: 16px; font-weight: 600; color: var(--fm-text); margin-bottom: 16px; }
.fm-modal-input {
  width: 100%; background: var(--fm-surface2); border: 1.5px solid var(--fm-border2);
  border-radius: var(--fm-radius-sm); padding: 9px 12px;
  color: var(--fm-text); font-family: var(--fm-font); font-size: 14px; outline: none;
  transition: border-color 0.15s;
}
.fm-modal-input:focus { border-color: var(--fm-accent); }
.fm-modal-actions { display: flex; justify-content: flex-end; gap: 8px; margin-top: 16px; }
.fm-btn-cancel {
  background: none; border: 1px solid var(--fm-border2);
  color: var(--fm-text2); font-family: var(--fm-font); font-size: 13px;
  padding: 7px 16px; border-radius: var(--fm-radius-sm); cursor: pointer;
  transition: all 0.12s;
}
.fm-btn-cancel:hover { border-color: var(--fm-border2); color: var(--fm-text); }
.fm-btn-confirm {
  background: var(--fm-accent); color: #fff; border: none;
  font-family: var(--fm-font); font-size: 13px; font-weight: 500;
  padding: 7px 16px; border-radius: var(--fm-radius-sm); cursor: pointer;
  transition: opacity 0.12s;
}
.fm-btn-confirm:hover { opacity: 0.85; }
.fm-btn-confirm:disabled { opacity: 0.4; cursor: not-allowed; }
</style>
